import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "children"];
import styled from 'styled-components';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAIBadgedLabel = styled.div.withConfig({
  displayName: "AIFormControl__StyledAIBadgedLabel",
  componentId: "slfpkf-0"
})({
  display: 'flex',
  alignItems: 'start',
  '& > *': {
    flex: 1
  },
  '& > :last-child': {
    flex: 'none'
  }
});
export default function AIFormControl(_ref) {
  let {
      label,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(FormControl, Object.assign({
    label: /*#__PURE__*/_jsxs(StyledAIBadgedLabel, {
      children: [label, /*#__PURE__*/_jsx(AIBadge, {})]
    })
  }, rest, {
    children: children
  }));
}